// Generated by scripts/update-seeq-icons.js from src/svg/seeq/trend.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcTrend = {
  prefix: 'fak',
  iconName: 'trend' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e914',
    'M890.9 573.4l-117.8-435.2c-5.1-15.4-20.5-25.6-35.8-30.7-15.4 0-30.7 10.2-35.9 25.6l-122.8 368.7-102.4-112.7c-10.2-10.2-20.5-15.4-35.9-10.2-10.2 0-25.6 10.2-30.7 20.5l-128 281.6-92.2-92.2c-5.1-5.1-15.4 0-15.3 5.1v66.6c0 10.2 5.1 20.5 10.2 25.6l81.9 81.9c5.1 5.1 15.4 10.2 25.6 10.2 0 0 5.1 0 5.2 0 10.2 0 20.5-10.2 25.6-20.4l128-276.5 107.5 117.7c10.2 10.2 20.5 15.4 35.8 10.3s25.6-10.2 30.7-25.6l102.4-307.2 117.8 440.3c5.1 15.4 20.5 25.6 35.8 30.7 15.4 0 30.7-10.2 35.9-25.6l40.9-128c0-5.1 0-10.2 0-10.2v-189.5c0-10.2-10.2-10.2-15.3 0l-51.2 179.2zM117.8 911.4v-890.9c0-10.2-10.2-20.5-20.5-20.5h-76.8c-10.2 0-20.5 10.2-20.5 20.5v947.2c0 30.7 25.6 56.3 56.3 56.3h947.2c10.2 0 20.5-10.2 20.5-20.5v-76.8c0-10.2-10.2-20.5-20.5-20.5h-885.7z',
  ],
} satisfies IconDefinition;
